import React from 'react'
import "./DescriptionBox.css"

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reveals (122) </div>
      </div>
      <div className="descriptionbox-description">
        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique voluptas saepe distinctio eos quae, eum quaerat, sit commodi enim totam reprehenderit blanditiis! Quae vero eveniet aliquid numquam laboriosam quis quibusdam alias inventore, saepe, dolore exercitationem explicabo, deleniti deserunt a maxime offer due to their infancy.</p>
      </div>
    </div>
  )
}

export default DescriptionBox 
